import React from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useIntl } from 'react-intl';

import Form, { FormTextField } from '@ts-core/core/components/FormV2';

import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import { UpdateProfileInput } from '@ts-core/modules/auth/types/Auth';

export interface ProfessorBasicProfileInfoFormProps {
  profileData: UpdateProfileInput;

  onSubmit: (data: UpdateProfileInput) => void;

  isSubmitting: boolean;
  submitError?: string;
}

const BasicProfileInfoFormSchema = Yup.object({
  name: Yup.string().required('El nombre es requerido'),
  email: Yup.string().email('El email no es válido').required('El email es requerido'),
});

const BasicProfileInfoForm = (props: ProfessorBasicProfileInfoFormProps) => {
  const { onSubmit, isSubmitting, submitError, profileData } = props;
  const intl = useIntl();

  const { handleSubmit, formState, control } = useForm<UpdateProfileInput>({
    resolver: yupResolver(BasicProfileInfoFormSchema),
    defaultValues: profileData,
  });

  return (
    <Box boxShadow={1}>
      <Box height={48} display="flex" flexDirection="row" alignItems="center" p={2}>
        <Typography variant="subtitle2" gutterBottom>
          {intl.formatMessage({ id: 'profile.basicInformation' })}
        </Typography>
      </Box>
      <Divider />
      <Form
        sx={{ width: '100%', p: 2 }}
        onSubmit={handleSubmit(onSubmit)}
        isSubmitting={isSubmitting}
        submitError={submitError}
        formState={formState}
      >
        <Stack spacing={2}>
          <FormTextField
            control={control}
            name="name"
            rules={{ required: true }}
            fullWidth
            label={intl.formatMessage({ id: 'field.name.label' })}
            defaultValue=""
          />
          <FormTextField
            control={control}
            name="email"
            rules={{ required: true }}
            type="email"
            fullWidth
            label={intl.formatMessage({ id: 'field.email.label' })}
          />
        </Stack>
      </Form>
    </Box>
  );
};

export default BasicProfileInfoForm;
